class VacationsAbsencesManager {
  constructor() {
    this.employeesOutOffice = {};
    this.listRequestsEmployees = [];
  }

}

export default VacationsAbsencesManager;



// WEBPACK FOOTER //
// ./client/app/common/domain/models/vacationsAbsencesManager.js